module.exports = __webpack_public_path__ + "img/np_design_2825693_F0CD5E.9eeeab4b.svg";